export default "__VITE_ASSET__DPVeQPZT__"